import React, { useCallback, useEffect, useState } from 'react';
import styles from './TextEditor.module.scss';
import './styles.css';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Label from '../label/Label';
import { ToolBar } from './tool-bar/ToolBar';
import { modules, formats } from './tool-bar/ToolBar';
import debounce from 'lodash.debounce';
import { variableManagement } from 'hooks/endpoints';
import { useFetch } from 'hooks/useFetch';
import { useBrandingContext } from 'app-context/BrandingsContext';

const TextEditor = ({
  label,
  placeholder,
  name,
  value,
  onChange,
  error,
  touched,
  isLoading,
  customFormats,
  className,
  isSave = false,
  isToolbarReduced = false,
  isCustom = false,
  onSaveClick,
  textEditorClassName,
}) => {
  const { brandingData } = useBrandingContext();
  const { page_TextColor } = brandingData;
  const [editorContent, setEditorContent] = useState(value || '');
  const [toolbarId] = useState(
    () => `toolbar-${Math.random().toString(36).substring(2, 15)}`
  );
  const { data: allVariables } = useFetch(
    ['allVariables'],
    variableManagement.get,
    {
      enable: true,
    },
    {
      pageNumber: 1,
      pageSize: 2000,
    }
  );

  useEffect(() => {
    setEditorContent(value || '');
  }, [value]);

  const debouncedOnChange = useCallback(
    debounce((content) => {
      if (onChange) onChange(content);
    }, 100),
    [onChange]
  );

  const handleEditorChange = (content) => {
    setEditorContent(content);
    debouncedOnChange(content);
  };
  const getModules = () => ({
    toolbar: {
      container: `#${toolbarId}`,
    },
  });
  return (
    <div className={styles['editor-container']}>
      <Label text={label} />
      <div className={`textEditorCont ${className ?? ''}`}>
        <ToolBar
          setEditorContent={setEditorContent}
          editorContent={editorContent}
          isSave={isSave}
          isCustom={isCustom ?? false}
          isToolbarReduced={isToolbarReduced ?? false}
          id={toolbarId}
          onSaveClick={onSaveClick}
          options={allVariables}
        />
        <ReactQuill
          value={isLoading ? '...' : editorContent}
          onChange={handleEditorChange}
          modules={getModules()}
          formats={customFormats ?? formats}
          placeholder={placeholder ?? 'Enter Content'}
          className={`${styles['text-editor']} ${textEditorClassName ?? ''}`}
          style={{ color: page_TextColor }}
        />
      </div>

      {error && touched && <div className="error-message">{error}</div>}
    </div>
  );
};

export default TextEditor;
